import { Fragment } from 'react';

import { Divider } from '@mui/material';

import { SidebarGroup } from '../components/sidebar-group';
import { SidebarItem } from '../components/sidebar-item';
import { SidebarRouteType } from '../lessor-sidebar-routes';

type Props = {
  links: SidebarRouteType[];
};

export const SidebarMenu = ({ links }: Props) => {
  return (
    <>
      {links.map((item, index, arr) => {
        const isFirst = index === 0;
        const isLast = index === links.length - 1;

        if (item.heading && item.subRoutes) {
          return (
            <Fragment key={item.label}>
              <SidebarGroup
                key={item.label}
                title={item.label}
                items={item.subRoutes}
              />
              {index < arr.length - 1 && (
                <Divider
                  key={`${item.label}-divider`}
                  sx={{
                    my: 1,
                    mx: -3,
                    borderColor: (theme) => theme.palette.fog['90'],
                    // width: '100%',
                  }}
                />
              )}
            </Fragment>
          );
        }

        if (item.route) {
          return (
            <Fragment key={item.label}>
              <SidebarItem
                key={item.label}
                to={item.route}
                label={item.label}
                icon={item.icon}
              />
              {!isLast && (
                <Divider
                  key={`${item.label}-divider`}
                  sx={{
                    my: 1,
                    mx: -3,
                    borderColor: (theme) => theme.palette.fog['90'],
                    // width: '100%',
                  }}
                />
              )}
            </Fragment>
          );
        }

        return null;
      })}
    </>
  );
};
